module.exports = __webpack_public_path__ + "media/partners/oponeo-ef23691a.png";